<template>
  <div class="dialog__overlay" @click="closeDialog">
    <div class="dialog" @click.stop>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  methods: {
    closeDialog(e) {
      e.target.classList.remove('show');
    }
  }
}
</script>

<style scoped>
.dialog__overlay {
  align-items: flex-start;
  background-color: rgba(24, 24, 24, 0.75);
  justify-content: center;
  overflow-y: auto;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 110;
  display: none;
}

.dialog {
  background-color: #F7F7F7;
  padding: 24px;
  margin: 40px 12px 0 12px;
  overflow: hidden;
  position: relative;
  z-index: 115;
}
</style>
